<template>
  <TemplateDataGrid gridId="PeUniformExamScheduleArrange"
                    v-bind="gridParams"></TemplateDataGrid>
</template>

<script>
import TemplateDataGrid from '../../../../../../../templates/TemplateDataGrid'
export default {
  name: 'ExamUniformScheduleArrange',
  components: {
    TemplateDataGrid
  },
  props: {
    batchId: {
      type: String,
      required: true
    }
  },
  computed: {
    gridParams () {
      return {
        batchId: this.batchId
      }
    }
  }
}
</script>
